import { render, staticRenderFns } from "./personalize-resource.vue?vue&type=template&id=327cf040"
import script from "./personalize-resource.vue?vue&type=script&lang=ts"
export * from "./personalize-resource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports